module.exports = __webpack_public_path__ + "img/portfolio-details-light.2717c0d8.png";